import { getData, postData, putData, deleteData, extractFile } from './index';
import { USER_ERROR, 
  FETCH_USERS, 
  FETCH_USER, 
  FETCH_USER_LIST, 
  CREATE_USER, 
  EXPORT_USERS_LIST, 
  UPDATE_USER, 
  DELETE_USER, 
  USER_RESET, 
  LOADING } from './types';

//= ===============================
// User actions
//= ===============================

export function fetchUsers() {
  return async (dispatch) => {
    const url = '/user';
    await dispatch({
      type: LOADING,
    });
    return getData(FETCH_USERS, USER_ERROR, true, url, dispatch);
  };
}

export function sendInvit(documentId) {
    const url = '/user/invit/' +documentId;
  return dispatch => getData(UPDATE_USER, USER_ERROR, true, url, dispatch);
}

export function fetchUser(documentId) {
  return async (dispatch) => {
    const url = '/user/' +documentId;
    await dispatch({
      type: LOADING,
    });
    await dispatch({
      type: USER_RESET,
      payload: null,
    });
    return getData(FETCH_USER, USER_ERROR, true, url, dispatch)
  };
}

export function getAutocompleteList(documentId) {
    const url = `/user/autocompleteList/${documentId}`
  return dispatch => getData(FETCH_USER_LIST, USER_ERROR, true, url, dispatch);
}

export function getUsersList() {
  const url = '/user/getUsersList'
  return dispatch => getData(FETCH_USER_LIST, USER_ERROR, true, url, dispatch);
}

export function getExportUsersList() {
  return async (dispatch) => {
    const url = '/user/export'
    await dispatch({
      type: LOADING,
    });
    return extractFile(EXPORT_USERS_LIST, USER_ERROR, true, url, dispatch);
  };
} 

export function createUser(document) {
    const data = { document };
  const url = '/user';
  return dispatch => postData(CREATE_USER, USER_ERROR, true, url, dispatch, data);
}

export function updateUser(document, documentId) {
  const data = { document };
    const url = '/user/' +documentId
  return dispatch => putData(UPDATE_USER, USER_ERROR, true, url, dispatch, data);
}

export function deleteUser(user) {
  const url = '/user/'+user;
  return dispatch => deleteData(DELETE_USER, USER_ERROR, true, url, dispatch);
}
